<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer000">
<p class="ORIM-Book-Title">Perfect Gallows</p>
<p class="ORIM-Book-Subtitle">A Crime Novel</p>
<p class="ORIM-Author-Name">Peter Dickinson</p>
<p class="center"><img alt="logo" src="image/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dickinson_PerfectGallows_3P_MD.vue?39398228